// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AaFitController from "./aa_fit_controller"
application.register("aa-fit", AaFitController)

import AnonymousBookmarkController from "./anonymous_bookmark_controller"
application.register("anonymous-bookmark", AnonymousBookmarkController)

import BalancedRowsController from "./balanced_rows_controller"
application.register("balanced-rows", BalancedRowsController)

import BengoshiMapGameController from "./bengoshi_map_game_controller"
application.register("bengoshi-map-game", BengoshiMapGameController)

import BlockEditorController from "./block_editor_controller"
application.register("block-editor", BlockEditorController)

import BookmarkListController from "./bookmark_list_controller"
application.register("bookmark-list", BookmarkListController)

import BulkSelectController from "./bulk_select_controller"
application.register("bulk-select", BulkSelectController)

import ClickableController from "./clickable_controller"
application.register("clickable", ClickableController)

import ClickableRowController from "./clickable_row_controller"
application.register("clickable-row", ClickableRowController)

import ClipboardButtonController from "./clipboard_button_controller"
application.register("clipboard-button", ClipboardButtonController)

import ClipboardCopyController from "./clipboard_copy_controller"
application.register("clipboard-copy", ClipboardCopyController)

import CodemirrorController from "./codemirror_controller"
application.register("codemirror", CodemirrorController)

import ColorPreviewController from "./color_preview_controller"
application.register("color-preview", ColorPreviewController)

import ColorSyncController from "./color_sync_controller"
application.register("color-sync", ColorSyncController)

import ConfirmLeaveController from "./confirm_leave_controller"
application.register("confirm-leave", ConfirmLeaveController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import DebugController from "./debug_controller"
application.register("debug", DebugController)

import DelayedPopoverController from "./delayed_popover_controller"
application.register("delayed-popover", DelayedPopoverController)

import DesignSwitcherController from "./design_switcher_controller"
application.register("design-switcher", DesignSwitcherController)

import DetailsAutocloseController from "./details_autoclose_controller"
application.register("details-autoclose", DetailsAutocloseController)

import DiagramPlayerController from "./diagram_player_controller"
application.register("diagram-player", DiagramPlayerController)

import DiceController from "./dice_controller"
application.register("dice", DiceController)

import DismissableController from "./dismissable_controller"
application.register("dismissable", DismissableController)

import DotMapController from "./dot_map_controller"
application.register("dot-map", DotMapController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FlightController from "./flight_controller"
application.register("flight", FlightController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import GeolocationController from "./geolocation_controller"
application.register("geolocation", GeolocationController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HighlightController from "./highlight_controller"
application.register("highlight", HighlightController)

import HistoryListController from "./history_list_controller"
application.register("history-list", HistoryListController)

import ImageFallbackController from "./image_fallback_controller"
application.register("image-fallback", ImageFallbackController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import JapanMapController from "./japan_map_controller"
application.register("japan-map", JapanMapController)

import JapanMapSvgController from "./japan_map_svg_controller"
application.register("japan-map-svg", JapanMapSvgController)

import JsonEditorController from "./json_editor_controller"
application.register("json-editor", JsonEditorController)

import LabelPreviewController from "./label_preview_controller"
application.register("label-preview", LabelPreviewController)

import LabelSelectorController from "./label_selector_controller"
application.register("label-selector", LabelSelectorController)

import LikeHintController from "./like_hint_controller"
application.register("like-hint", LikeHintController)

import LineChartController from "./line_chart_controller"
application.register("line-chart", LineChartController)

import LinkPreviewController from "./link_preview_controller"
application.register("link-preview", LinkPreviewController)

import ListSortController from "./list_sort_controller"
application.register("list-sort", ListSortController)

import LiveDiffController from "./live_diff_controller"
application.register("live-diff", LiveDiffController)

import LogViewerController from "./log_viewer_controller"
application.register("log-viewer", LogViewerController)

import MarginNotesController from "./margin_notes_controller"
application.register("margin-notes", MarginNotesController)

import MetricGraphController from "./metric_graph_controller"
application.register("metric-graph", MetricGraphController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import PeriodToggleController from "./period_toggle_controller"
application.register("period-toggle", PeriodToggleController)

import PracticeAreaTreeController from "./practice_area_tree_controller"
application.register("practice-area-tree", PracticeAreaTreeController)

import PrefectureHighlightController from "./prefecture_highlight_controller"
application.register("prefecture-highlight", PrefectureHighlightController)

import PreviewController from "./preview_controller"
application.register("preview", PreviewController)

import RangeDisplayController from "./range_display_controller"
application.register("range-display", RangeDisplayController)

import ReplayWebPageController from "./replay_web_page_controller"
application.register("replay-web-page", ReplayWebPageController)

import ReviewDraftController from "./review_draft_controller"
application.register("review-draft", ReviewDraftController)

import ReviewDraftListController from "./review_draft_list_controller"
application.register("review-draft-list", ReviewDraftListController)

import RowAccordionController from "./row_accordion_controller"
application.register("row-accordion", RowAccordionController)

import SaikoroTalkController from "./saikoro_talk_controller"
application.register("saikoro-talk", SaikoroTalkController)

import ScrollToTopController from "./scroll_to_top_controller"
application.register("scroll-to-top", ScrollToTopController)

import SelectMenuController from "./select_menu_controller"
application.register("select-menu", SelectMenuController)

import SelectionLoaderController from "./selection_loader_controller"
application.register("selection-loader", SelectionLoaderController)

import ShowModalController from "./show_modal_controller"
application.register("show-modal", ShowModalController)

import SpoilerController from "./spoiler_controller"
application.register("spoiler", SpoilerController)

import StarPreviewController from "./star_preview_controller"
application.register("star-preview", StarPreviewController)

import StatusGraphController from "./status_graph_controller"
application.register("status-graph", StatusGraphController)

import StepAccordionController from "./step_accordion_controller"
application.register("step-accordion", StepAccordionController)

import StickyController from "./sticky_controller"
application.register("sticky", StickyController)

import SubmitLockController from "./submit_lock_controller"
application.register("submit-lock", SubmitLockController)

import TabScrollController from "./tab_scroll_controller"
application.register("tab-scroll", TabScrollController)

import TableResizeController from "./table_resize_controller"
application.register("table-resize", TableResizeController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TextareaResizeController from "./textarea_resize_controller"
application.register("textarea-resize", TextareaResizeController)

import TimelineTimeInputController from "./timeline_time_input_controller"
application.register("timeline-time-input", TimelineTimeInputController)

import ToastItemController from "./toast_item_controller"
application.register("toast-item", ToastItemController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)

import TwitterWidgetLoaderController from "./twitter_widget_loader_controller"
application.register("twitter-widget-loader", TwitterWidgetLoaderController)

import ViewingHistoryController from "./viewing_history_controller"
application.register("viewing-history", ViewingHistoryController)
